import { render, staticRenderFns } from "./CodeRules.vue?vue&type=template&id=d21a2c88&scoped=true"
import script from "./CodeRules.vue?vue&type=script&lang=js"
export * from "./CodeRules.vue?vue&type=script&lang=js"
import style0 from "./CodeRules.vue?vue&type=style&index=0&id=d21a2c88&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d21a2c88",
  null
  
)

export default component.exports